<template>
  <form class="sidebar__form" :class="{'active': showMobileFilter}">
    <div class="sidebar__form-wrapper">
      <div class="sidebar__filter">

        <div class="sidebar__filter-header">
          <h3 class="sidebar__header-title">{{ in18['page_filters'] }}</h3>
          <button class="sidebar__close" data-show=".sidebar__form" type="button"
                  @click="this.$store.dispatch('setFilters', false)">
            <img alt="" src="/shop/images/modal-close.svg">
          </button>
        </div>

        <div class="sidebar__content">

          <!-- Categories -->
          <template v-if="hasOptions(filters.category)">
            <catalog-filter-item
                :filterData="filters.category"
                :isCheckbox="false"
                :isLoading="isLoading"
                :selectedIds="selectedCategories"
                filterKey="categories"
                @changeFilter="changeFilter"
            />
          </template>

          <!-- Manufacturers Filter -->
          <template v-if="hasOptions(filters.manufacture)">
            <catalog-filter-item
                :filterData="filters.manufacture"
                :isLoading="isLoading"
                :selectedIds="selectedManufactures"
                filterKey="manufactures"
                @changeFilter="changeFilter"
            />
          </template>

          <!-- Discount Filter -->
          <template v-if="hasOptions(filters.discount)">
            <catalog-filter-item
                :filterData="filters.discount"
                :isLoading="isLoading"
                :selectedIds="selectedDiscounts"
                filterKey="discounts"
                @changeFilter="changeFilter"
            />
          </template>

          <!-- Inventory Filter -->
          <template v-if="hasOptions(filters.inventory)">
            <catalog-filter-item
                :filterData="filters.inventory"
                :isLoading="isLoading"
                :selectedIds="selectedInventories"
                filterKey="inventories"
                @changeFilter="changeFilter"
            />
          </template>

          <template v-for="property in filters.property" :key="property.id">
            <div class="sidebar__block">
              <h3 class="sidebar__title active">
                {{ property.title }}
              </h3>
              <div class="filter active">
                <div v-for="propertyOption in property.options" class="form__group  form__group--sm">
                  <div class="checkbox  checkbox--sm">
                    <input :id="`property_option_${propertyOption.id}`"
                           v-model="selectedPropertyOptions"
                           :disabled="isLoading || parseFloat(propertyOption.count) === 0"
                           :value="propertyOption.id"
                           class="checkbox__input"
                           type="checkbox"
                           @change="changeFilter('properties', selectedPropertyOptions)"
                    >
                    <label :for="`property_option_${propertyOption.id}`" class="checkbox__label  checkbox__label--flex">
                      <span v-html="propertyOption.title"></span>
                      <span class="checkbox__count">{{ propertyOption.count }}</span>
                    </label>
                  </div>
                </div>
              </div><!-- /.filter -->
            </div><!-- /.sidebar__block -->
          </template>
        </div><!-- /.sidebar__content -->
      </div><!-- /.sidebar__filter -->

      <button class="btn  btn--reset  jsResetRange" type="reset" @click="clearFilter">
        {{ in18['page_clear_filters'] }}
      </button>
    </div><!-- /.sidebar__form-wrapper -->
  </form>
</template>

<script>

import CatalogFilterItem from "./CatalogFilterItem.vue";

export default {
  components: {
    CatalogFilterItem,
  },
  props:      {
    isLoading: Boolean,
    filters:   Object,
    params:    Object,
    in18:      Object,
  },

  data() {
    const params = this.params || {};
    // const priceFromOption = this.filters.price.options.find(option => option.id === 'price_from');
    // const priceToOption = this.filters.price.options.find(option => option.id === 'price_to');

    return {
      selectedDiscounts:       params.discounts || [],
      selectedCategories:      params.categories || [],
      selectedPropertyOptions: params.properties || [],
      selectedInventories:     params.inventories || [],
      selectedManufactures:    params.manufactures || [],
      // selectedFormPrice:       params.price_from || (priceFromOption ? parseFloat(priceFromOption.value) : 0),
      // selectedToPrice:         params.price_to || (priceToOption ? parseFloat(priceToOption.value) : 0),
    };
  },

  emits: [
    'changeFilter',
    'clearFilter'
  ],

  watch: {
    params: {
      handler(val, oldVal) {
        this.getSelects();
      },
      deep: true
    },
  },

  methods: {
    getSelects() {
      const params = this.params || {};
      // const priceFromOption = this.filters.price.options.find(option => option.id === 'price_from');
      // const priceToOption = this.filters.price.options.find(option => option.id === 'price_to');

      this.selectedDiscounts = params.discounts || [];
      this.selectedCategories = params.categories || [];
      this.selectedPropertyOptions = params.properties || [];
      this.selectedInventories = params.inventories || [];
      this.selectedManufactures = params.manufactures || [];
      // this.selectedFormPrice = params.price_from || (priceFromOption ? parseFloat(priceFromOption.value) : 0);
      // this.selectedToPrice = params.price_to || (priceToOption ? parseFloat(priceToOption.value) : 0);

      return {
        selectedDiscounts:       this.selectedDiscounts,
        selectedCategories:      this.selectedCategories,
        selectedPropertyOptions: this.selectedPropertyOptions,
        selectedInventories:     this.selectedInventories,
        selectedManufactures:    this.selectedManufactures,
        // selectedFormPrice:       this.selectedFormPrice,
        // selectedToPrice:         this.selectedToPrice,
      }
    },
    /**
     * Check if a filter has options.
     * @param {Object} filter - The filter to check.
     * @returns {boolean} - True if the filter has options, otherwise false.
     */
    hasOptions(filter) {
      return filter && filter.options && filter.options.length > 0;
    },
    /**
     * Emit a change filter event.
     * @param {string} prop - The property to change.
     * @param {any} data - The new data for the property.
     */
    changeFilter(prop, data) {
      this.$emit('changeFilter', prop, data);
    },
    /**
     * Emit a clear filter event.
     */
    clearFilter() {
      this.$emit('clearFilter');
    },

    updateScreenWidth() {
      //reset drawer variable on resize, else drawer bugs out and cant be opened again
      this.$store.dispatch('setFilters', false)
    },
  },

  computed: {
    showMobileFilter() {
      return this.$store.getters.showMobileFilters
    }
  },

  mounted() {
    window.addEventListener('resize', this.updateScreenWidth);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateScreenWidth);
  },
};
</script>
